import {
  BriefcaseIcon,
  StoreIcon,
  SchoolIcon,
  StethoscopeIcon,
  ChurchIcon,
  UtensilsCrossedIcon,
  WarehouseIcon,
  KeyRoundIcon,
  HomeIcon,
  BuildingIcon,
  Building2Icon,
  UsersIcon,
  LandmarkIcon,
  ConstructionIcon,
  HammerIcon,
  TrendingUpIcon,
  ShieldCheckIcon,
  BadgeCheckIcon,
  ClockIcon,
  CalendarClockIcon,
  ThumbsUpIcon,
  MessagesSquareIcon,
  ClipboardListIcon,
  HardHatIcon,
  SearchCheckIcon,
} from 'lucide-react';
import type { IconItem } from '../types/content';

export const benefits: IconItem[] = [
  {
    icon: ShieldCheckIcon,
    title: { en: 'Licensed & Insured', es: 'Con Licencia y Seguro' },
    description: {
      en: 'Full liability coverage on every job, with certificates available on request.',
      es: 'Cobertura de responsabilidad completa en cada trabajo, con certificados disponibles.',
    },
  },
  {
    icon: UsersIcon,
    title: { en: 'Professional Team', es: 'Equipo Profesional' },
    description: {
      en: 'Trained, background-checked painters, respectful in your home or business.',
      es: 'Pintores capacitados y verificados, respetuosos en su hogar o negocio.',
    },
  },
  {
    icon: BadgeCheckIcon,
    title: { en: 'High-Quality Materials', es: 'Materiales de Alta Calidad' },
    description: {
      en: 'Premium residential and commercial-grade paints chosen for durability.',
      es: 'Pinturas premium residenciales y de grado comercial, elegidas por su durabilidad.',
    },
  },
  {
    icon: ClockIcon,
    title: { en: 'Reliable & On Time', es: 'Puntuales y Confiables' },
    description: {
      en: 'We show up when we say we will and finish on the schedule we quote.',
      es: 'Llegamos cuando lo prometemos y terminamos en el plazo acordado.',
    },
  },
  {
    icon: CalendarClockIcon,
    title: { en: 'Flexible Scheduling', es: 'Horarios Flexibles' },
    description: {
      en: 'After-hours work for businesses, convenient times for families — 7 days a week.',
      es: 'Fuera de horario para negocios y en horarios cómodos para familias — 7 días a la semana.',
    },
  },
  {
    icon: ThumbsUpIcon,
    title: { en: 'Satisfaction Guaranteed', es: 'Satisfacción Garantizada' },
    description: {
      en: 'If something is not right, we come back and fix it at no charge.',
      es: 'Si algo no queda bien, regresamos y lo corregimos sin costo.',
    },
  },
];

export const commercialClients: IconItem[] = [
  { icon: BriefcaseIcon, title: { en: 'Corporate Offices', es: 'Oficinas Corporativas' }, description: { en: 'Weekend repaints with zero downtime.', es: 'Repintado en fin de semana, sin interrupciones.' } },
  { icon: StoreIcon, title: { en: 'Retail Stores & Shopping Centers', es: 'Tiendas y Centros Comerciales' }, description: { en: 'Storefront and tenant-space refreshes.', es: 'Renovación de fachadas y locales.' } },
  { icon: SchoolIcon, title: { en: 'Schools & Daycare Centers', es: 'Escuelas y Guarderías' }, description: { en: 'Low-VOC paints during school breaks.', es: 'Pinturas de bajo VOC en vacaciones escolares.' } },
  { icon: StethoscopeIcon, title: { en: 'Medical & Dental Offices', es: 'Consultorios Médicos y Dentales' }, description: { en: 'Washable, durable clinical finishes.', es: 'Acabados lavables y resistentes.' } },
  { icon: ChurchIcon, title: { en: 'Churches & Ministries', es: 'Iglesias y Ministerios' }, description: { en: 'Sanctuaries, halls, and exteriors.', es: 'Santuarios, salones y exteriores.' } },
  { icon: UtensilsCrossedIcon, title: { en: 'Restaurants & Cafes', es: 'Restaurantes y Cafeterías' }, description: { en: 'Grease-resistant coatings and refreshes.', es: 'Recubrimientos resistentes a grasa.' } },
  { icon: WarehouseIcon, title: { en: 'Warehouses & Industrial', es: 'Almacenes e Industrias' }, description: { en: 'High ceilings, steel, and epoxy floors.', es: 'Techos altos, acero y pisos epóxicos.' } },
  { icon: KeyRoundIcon, title: { en: 'Property Management Groups', es: 'Administradoras de Propiedades' }, description: { en: 'One painting partner for every building.', es: 'Un solo proveedor para todos sus edificios.' } },
];

export const residentialClients: IconItem[] = [
  { icon: HomeIcon, title: { en: 'Single Family Homes', es: 'Casas Unifamiliares' }, description: { en: 'One room or the whole house, inside and out.', es: 'Una habitación o toda la casa, por dentro y por fuera.' } },
  { icon: BuildingIcon, title: { en: 'Townhomes & Condos', es: 'Townhomes y Condominios' }, description: { en: 'HOA-approved colors and tidy work.', es: 'Colores aprobados por la HOA y trabajo limpio.' } },
  { icon: UsersIcon, title: { en: 'Multi-Family Residences', es: 'Residencias Multifamiliares' }, description: { en: 'Duplexes and shared-wall homes.', es: 'Dúplex y viviendas compartidas.' } },
  { icon: LandmarkIcon, title: { en: 'Historic Homes', es: 'Casas Históricas' }, description: { en: 'Careful prep for original woodwork.', es: 'Preparación cuidadosa de la madera original.' } },
  { icon: ConstructionIcon, title: { en: 'New Construction Homes', es: 'Casas de Obra Nueva' }, description: { en: 'Builder-ready interior and exterior paint.', es: 'Pintura interior y exterior lista para entrega.' } },
  { icon: HammerIcon, title: { en: 'Home Renovations', es: 'Remodelaciones' }, description: { en: 'Drywall, texture, and paint after remodels.', es: 'Drywall, textura y pintura tras remodelar.' } },
  { icon: TrendingUpIcon, title: { en: 'Investment Properties', es: 'Propiedades de Inversión' }, description: { en: 'Fast turnovers that boost rental value.', es: 'Renovaciones rápidas que aumentan el valor.' } },
  { icon: Building2Icon, title: { en: 'Multi-Unit Residential', es: 'Residencial Multi-Unidad' }, description: { en: 'Unit-by-unit repaints on your schedule.', es: 'Repintado unidad por unidad según su agenda.' } },
];

export const processSteps: IconItem[] = [
  {
    icon: MessagesSquareIcon,
    title: { en: 'Consultation', es: 'Consulta' },
    description: {
      en: 'We visit your property, walk the space with you, and learn your schedule, goals, and budget.',
      es: 'Visitamos su propiedad, recorremos el espacio con usted y conocemos su horario, metas y presupuesto.',
    },
  },
  {
    icon: ClipboardListIcon,
    title: { en: 'Estimate', es: 'Presupuesto' },
    description: {
      en: 'You receive a clear, detailed written estimate within 48 hours — free and with no obligation.',
      es: 'Recibe un presupuesto escrito, claro y detallado en 48 horas — gratis y sin compromiso.',
    },
  },
  {
    icon: HardHatIcon,
    title: { en: 'Execution', es: 'Ejecución' },
    description: {
      en: 'Our professional crew protects your property and works around your schedule, keeping you updated throughout.',
      es: 'Nuestro equipo protege su propiedad, trabaja según su horario y le mantiene informado en todo momento.',
    },
  },
  {
    icon: SearchCheckIcon,
    title: { en: 'Quality Check', es: 'Control de Calidad' },
    description: {
      en: 'Our supervisor inspects every detail with you before completion. Your satisfaction guaranteed.',
      es: 'Nuestro supervisor revisa cada detalle con usted antes de terminar. Su satisfacción, garantizada.',
    },
  },
];
